export const topics = [
  {
    id: "topic-consumer",
    title: "年末消费避坑档案",
    desc: "把一整年里读者投稿最多的退换货、预付费、会员自动续费套路整理成一份可查的避坑清单。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20still%20life%20of%20a%20paper%20receipt%20magnifying%20glass%20and%20a%20cup%20of%20tea%20on%20a%20wooden%20desk%2C%20soft%20amber%20lamp%20light%2C%20cinematic%20documentary%20photography%2C%20no%20text&width=900&height=1200&seq=topic-consumer-01&orientation=portrait",
    count: 24,
    tag: "消费维权",
  },
  {
    id: "topic-livestream",
    title: "直播带货售后实录",
    desc: "镜头前喊得响，售后入口藏得深。这里汇总读者递交的直播下单、退款无门的真实记录。",
    cover:
      "https://readdy.ai/api/search-image?query=moody%20home%20studio%20corner%20with%20a%20ring%20light%20switched%20off%20and%20a%20tripod%2C%20warm%20dim%20ambient%20light%2C%20cinematic%20editorial%20photography%2C%20no%20text&width=900&height=1200&seq=topic-live-01&orientation=portrait",
    count: 18,
    tag: "行业内幕",
  },
  {
    id: "topic-workplace",
    title: "打工人维权档案",
    desc: "试用期辞退、加班口径、竞业条款，收录投稿人匿名提供的沟通截图与处理结果。",
    cover:
      "https://readdy.ai/api/search-image?query=empty%20office%20desk%20at%20night%20with%20a%20stack%20of%20signed%20papers%20and%20a%20desk%20lamp%2C%20warm%20amber%20glow%2C%20cinematic%20corporate%20documentary%20photography%2C%20no%20text&width=900&height=1200&seq=topic-work-01&orientation=portrait",
    count: 31,
    tag: "行业内幕",
  },
  {
    id: "topic-device",
    title: "智能硬件翻车合集",
    desc: "参数与实测不符、固件更新后功能缩水、维修报价不透明，读者投稿逐条对照。",
    cover:
      "https://readdy.ai/api/search-image?query=disassembled%20smart%20device%20parts%20arranged%20on%20a%20dark%20mat%20with%20warm%20focused%20light%2C%20cinematic%20macro%20technology%20photography%2C%20no%20text&width=900&height=1200&seq=topic-device-01&orientation=portrait",
    count: 15,
    tag: "科技数码",
  },
];